import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import cookiesStore from '../../store/cookiesStore';
import { TTranslate } from '~/types/main';
import MultiLanguageTextEditor from '~/view/components/TextEditor/MultiLanguageTextEditor';

const CookiesMessageInput: FC = observer((): ReactElement => {
  const { isFirstLoading, cookies } = cookiesStore;

  const onMessageChanged = useCallback((message: TTranslate) => {
    cookiesStore.changeCookiesHandler({ message });
  }, []);

  return (
    <div className="d-flex flex-column mb-2">
      {isFirstLoading ? (
        <div className="d-flex flex-column gap-20">
          <Skeleton width={736} height={46} style={{ borderRadius: 12 }} />
          <Skeleton width="100%" height={426} style={{ borderRadius: 12 }} />
        </div>
      ) : (
        <MultiLanguageTextEditor enValue={cookies.message.en} arValue={cookies.message.ar} onChange={onMessageChanged} />
      )}
    </div>
  );
});

export default CookiesMessageInput;
